import { render, staticRenderFns } from "./RuleActionsSettings.vue?vue&type=template&id=97ff1ff2&scoped=true&"
import script from "./RuleActionsSettings.vue?vue&type=script&lang=ts&"
export * from "./RuleActionsSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RuleActionsSettings.vue?vue&type=style&index=0&id=97ff1ff2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ff1ff2",
  null
  
)

export default component.exports